import 'reflect-metadata';
import Vue, { CreateElement } from 'vue';
import BaseComponent from '@/mixins/BaseComponent';
// plugins
import '@/plugins/filters';
import '@/plugins/directives';
// entry component
import CartDetail from './Cart.vue';

new Vue({
	mixins: [BaseComponent],
	render(h: CreateElement) {
		return h(CartDetail);
	}
}).$mount('#cart');
